import { getCustomUserAgent } from "../../../common/customUserAgent";
import { getUuidAndSession } from "../../../common/localStorage";

export interface IDemFile {
  id: number;
  mime: string;
  name: string;
  size: number;
  url: string;
  base64?: string;
}

export interface IQuerySetDemRate {
  demandId: number;
  rate: number;
  comment: string;
}

export interface IQuerySetDemRateResult {
  loaded: boolean;
  fail: boolean;
  msg: string;
}

export const querySetDemRate = (
  demid: number,
  rate: number,
  comment: string,
  setDemRateRes: React.Dispatch<React.SetStateAction<IQuerySetDemRateResult>>
) => {
  fetch("https://izba.kras-abs.ru/api/v3/demand/setDemandRating", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      demandId: demid + "",
      rating: rate + "",
      ratingComment: comment + "",
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      // Успех бэк отдаёт как { success: true }
      const ok = !!(res && res.success === true);
      setDemRateRes({
        loaded: true,
        fail: !ok,
        msg: ok ? "Оценка сохранена" : (res && res.error ? res.error : JSON.stringify(res)),
      });
    })
    .catch((err) => {
      setDemRateRes({ loaded: true, fail: true, msg: err.message });
    });
};
